// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { assignBudgetsStyles } from "@insite/content-library/Widgets/Budget/AssignBudgets";
import { xScreen } from "@keller/XDL/Utilities";
import { pageTitleStyle } from "@keller/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

assignBudgetsStyles.titleText = pageTitleStyle;

assignBudgetsStyles.cancelButton = {
    variant: "secondary",
    css: css`
        order: 1;
        margin-left: 10px;
        ${xScreen("lte", "sm")} {
            width: 50%;
        }
        ${xScreen("lte", "xs")} {
            width: 100%;
            margin-left: 0;
            margin-top: 10px;
        }
    `,
};

assignBudgetsStyles.saveButton = {
    css: css`
        ${xScreen("lte", "sm")} {
            width: 50%;
        }
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

assignBudgetsStyles.tableGridItem = {
    width: 12,
    css: css`
        padding: 15px;
    `,
};

assignBudgetsStyles.titleGridItem = {
    width: [12, 12, 8, 8, 8],
};

assignBudgetsStyles.buttonsGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        justify-content: flex-end;
        ${xScreen("lte", "xs")} {
            flex-wrap: wrap;
        }
        & > div {
            display: flex;
            width: 100%;
            ${xScreen("lte", "xs")} {
                flex-wrap: wrap;
            }
            ${xScreen("gt", "sm")} {
                display: none;
            }
        }
    `,
};

assignBudgetsStyles.gridContainer = {};

assignBudgetsStyles.budgetYearGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        padding: 15px 15px 0 15px;
    `,
};

assignBudgetsStyles.wrapper = {
    css: css`
        display: inline-block;
        margin-bottom: 15px;
        width: 50%;
        ${xScreen("lte", "sm")} {
            width: 100%;
            margin-left: 0;
        }
    `,
};

assignBudgetsStyles.searchUserWrapper = {
    css: css`
        display: inline-block;
        margin-right: 30px;
        margin-bottom: 30px;
        width: 50%;
        ${xScreen("lte", "sm")} {
            width: 100%;
            margin-right: 0;
        }
    `,
};
assignBudgetsStyles.filterGridItem = {
    width: 12,
    css: css`
        display: flex;
        padding: 15px 15px 0 15px;
        ${xScreen("lte", "sm")} {
            flex-wrap: wrap;
        }
    `,
};

assignBudgetsStyles.enforcementLevelDisplayStyles = {
    labelText: {
        css: css`
            margin-bottom: 0;
            line-height: 19px;
        `,
    },
    valueText: {
        css: css`
            line-height: 19px;
        `,
    },
};
